module.exports = __webpack_public_path__ + "img/c5202009-4.59275a58.jpg";